// extracted by mini-css-extract-plugin
export default {"saveAsDraftButton":"footer-buttons_saveAsDraftButton__r-5U3","cancelButton":"footer-buttons_cancelButton__O3qh-","secondaryBtn":"footer-buttons_secondaryBtn__Qq-xQ"};